module.exports = __webpack_public_path__ + "media/images/soar/home_page_figure1-6fea7c954b7fd82eb1883de8c6fd55bf.png";